import { render } from "./ModalWindow.vue?vue&type=template&id=75624246&scoped=true"
import script from "./ModalWindow.vue?vue&type=script&lang=js"
export * from "./ModalWindow.vue?vue&type=script&lang=js"

import "./ModalWindow.vue?vue&type=style&index=0&id=75624246&scoped=true&lang=css"

import exportComponent from "/home/rich/web/spelling-bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75624246"]])

export default __exports__